export default "<app-user-header></app-user-header>\n<router-outlet></router-outlet>\n<app-user-footer></app-user-footer>"